import { gql } from 'apollo-boost';

export const ALL_BUSINESS_GQL = gql`
  query Businesses {
    businesses {
      city
      closed
      id
      name
      phone_number
      state
      street_1
      street_2
      zip
    }
  }
`;
